import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 bg-white rounded-lg text-darkgray-800"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold mb-2.5" }, "You do not have a patient record yet.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-sm" }, "Please fill up the patient record.", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Patient Details", -1)
const _hoisted_8 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-7" }
const _hoisted_9 = { class: "col-span-full lg:col-span-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "hidden col-span-4 lg:block" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "hidden col-span-4 lg:block" }, null, -1)
const _hoisted_12 = { class: "col-span-full lg:col-span-4" }
const _hoisted_13 = { class: "col-span-full lg:col-span-4" }
const _hoisted_14 = { class: "col-span-full lg:col-span-4" }
const _hoisted_15 = { class: "col-span-full lg:col-span-6" }
const _hoisted_16 = { class: "col-span-full lg:col-span-6" }
const _hoisted_17 = { class: "col-span-full lg:col-span-6" }
const _hoisted_18 = { class: "col-span-full lg:col-span-6" }
const _hoisted_19 = { class: "col-span-full lg:col-span-6" }
const _hoisted_20 = { class: "col-span-full lg:col-span-6" }
const _hoisted_21 = { class: "col-span-full lg:col-span-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Local Address", -1)
const _hoisted_24 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-7" }
const _hoisted_25 = { class: "col-span-full lg:col-span-6" }
const _hoisted_26 = { class: "col-span-full lg:col-span-6" }
const _hoisted_27 = { class: "col-span-full lg:col-span-6" }
const _hoisted_28 = { class: "col-span-full lg:col-span-6" }
const _hoisted_29 = { class: "col-span-full lg:col-span-6" }
const _hoisted_30 = { class: "col-span-full lg:col-span-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_32 = { class: "flex flex-wrap mb-6 lg:flex-nowrap lg:justify-between space-y-1.5 lg:space-y-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "w-full text-xl font-bold text-primary-500 lg:w-fit" }, "Permanent Address", -1)
const _hoisted_34 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-7" }
const _hoisted_35 = { class: "col-span-full lg:col-span-6" }
const _hoisted_36 = { class: "col-span-full lg:col-span-6" }
const _hoisted_37 = { class: "col-span-full lg:col-span-6" }
const _hoisted_38 = { class: "col-span-full lg:col-span-6" }
const _hoisted_39 = { class: "col-span-full lg:col-span-6" }
const _hoisted_40 = { class: "col-span-full lg:col-span-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_42 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-7" }
const _hoisted_43 = { class: "col-span-full lg:col-span-6" }
const _hoisted_44 = { class: "col-span-full lg:col-span-6" }
const _hoisted_45 = { class: "relative col-span-full lg:col-span-6" }
const _hoisted_46 = {
  for: "senior_citizen",
  class: "flex justify-between cursor-pointer relative rounded-full bg-zinc-50 border border-gray-900/[.04] frm-input w-full text-sm h-12 disabled:bg-gray-100 focus:outline-none focus:ring-0 px-5 pt-4 pb-1"
}
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 0,
  class: "absolute top-3 right-5 z-[2]"
}
const _hoisted_49 = { class: "relative col-span-full lg:col-span-6" }
const _hoisted_50 = {
  for: "pwd_id",
  class: "flex justify-between cursor-pointer relative rounded-full bg-zinc-50 border border-gray-900/[.04] frm-input w-full text-sm h-12 disabled:bg-gray-100 focus:outline-none focus:ring-0 px-5 pt-4 pb-1"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 0,
  class: "absolute top-3 right-5 z-[2]"
}
const _hoisted_53 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Occupation", -1)
const _hoisted_55 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-7" }
const _hoisted_56 = { class: "col-span-full lg:col-span-6" }
const _hoisted_57 = { class: "col-span-full lg:col-span-6" }
const _hoisted_58 = { class: "col-span-full lg:col-span-6" }
const _hoisted_59 = { class: "col-span-full lg:col-span-6" }
const _hoisted_60 = { class: "col-span-full" }
const _hoisted_61 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Person to notify in case of emergency", -1)
const _hoisted_63 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-7" }
const _hoisted_64 = { class: "col-span-full lg:col-span-6" }
const _hoisted_65 = { class: "col-span-full lg:col-span-6" }
const _hoisted_66 = { class: "col-span-full lg:col-span-6" }
const _hoisted_67 = { class: "col-span-full lg:col-span-6" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", null, "Please be informed that any changes that you wish to apply to your patient record will require you to contact Shinagawa.", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", null, "If all the information you input is final, click “Submit”.", -1)

import CalendarPicker from '@/components/CalendarPicker.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import FileInput from '@/components/inputs/FileInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import GeneralModal from '@/components/GeneralModal.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
// import { useRouter } from 'vue-router';
// const router = useRouter();
import patient from "@/classes/UserData";
import location from "@/classes/LocationService";
import medical from "@/classes/MedicalService";
import auth from "@/classes/AuthService";
import Storage from '@/helpers/storage';
import { numberonly } from '@/helpers/NumberHelper';
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { onMounted, ref, watch } from 'vue';
import { onKeypressNumbersOnly, onPasteNumbersOnly } from '@/helpers/ValidationHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicalRecordForm',
  setup(__props) {

const storage = new Storage();

const loader      = ref(false)
const show        = ref(false);
const showForm    = ref(false);
const showSuccess = ref(false);
const showError   = ref(false)
const errorMsg    = ref(null)
const errors      = ref([])
const sameAsLocal = ref()

const provinces = ref([]);
const cities    = ref([]);
const barangays = ref([]);

const permanentProvinces = ref([]);
const permanentCities    = ref([]);
const permanentBarangays = ref([]);

const hmoOptions = ref([]);

const patientData   = patient.getCurrentUser()
const sexes         = patient.getGender();
const civilStatuses = patient.getCivilStatuses();

const uploadedFileName1 = ref('')
const uploadedFileName2 = ref('')

const payload = ref({
    // Patient Details
    patient_id: patientData?.patient_id ?? null,
    last_name: patientData?.last_name ?? null,
    first_name: patientData?.first_name ?? null,
    middle_name: patientData?.middle_name ?? null,
    suffix: patientData?.suffix ?? null,
    cellphone_number: patientData?.cellphone_number ?? null,
    telephone_number: patientData?.telephone_number ?? null,
    civil_status: patientData?.civil_status ?? null,
    sex: patientData?.sex ?? null,
    nationality: patientData?.nationality ?? null,
    // Patient Address
    religion: patientData?.religion ?? null,
    job_title: patientData?.job_title ?? null,
    birthdate: patientData?.birthdate ?? null,
    birthplace: patientData?.birthplace ?? null,
    email_address: patientData?.email_address ?? null,
    building_number: patientData?.building_number ?? null,
    street: patientData?.street ?? null,
    barangay: patientData?.barangay ?? null,
    barangay_code: patientData?.barangay_code ?? null,
    city: patientData?.city ?? null,
    city_code: patientData?.city_code ?? null,
    province: patientData?.province ?? null,
    province_code: patientData?.province_code ?? null,
    region: patientData?.region ?? null,
    region_code: patientData?.region_code ?? null,
    zip_code: patientData?.zip_code ?? null,
    philhealth_number: patientData?.philhealth_number ?? null,
    hmo_id: patientData?.hmo_id ?? null,
    hmo_name: patientData?.hmo_name ?? null,
    senior_citizen_id_base_64: patientData?.senior_citizen_id_base_64 ?? null,
    pwd_id_base_64: patientData?.pwd_id_base_64 ?? null,
    // Emergency Contact Person Details
    company_name: patientData?.company_name ?? null,
    company_email: patientData?.company_email ?? null,
    company_address: patientData?.company_address ?? null,
    contact_person_name: patientData?.contact_person_name ?? null,
    contact_person_relationship: patientData?.contact_person_relationship ?? null,
    contact_person_number: patientData?.contact_person_number ?? null,
    contact_person_email: patientData?.contact_person_email ?? null,
    company_contact_no: patientData?.company_contact_no ?? null,
    // Permanent address
    permanent_building_number: patientData?.permanent_building_number ?? null,
    permanent_street: patientData?.permanent_street ?? null,
    permanent_barangay: patientData?.permanent_barangay ?? null,
    permanent_barangay_code: patientData?.permanent_barangay_code ?? null,
    permanent_city: patientData?.permanent_city ?? null,
    permanent_city_code: patientData?.permanent_city_code ?? null,
    permanent_province: patientData?.permanent_province ?? null,
    permanent_province_code: patientData?.permanent_province_code ?? null,
    permanent_region: patientData?.permanent_region ?? null,
    permanent_region_code: patientData?.permanent_region_code ?? null,
    permanent_zip_code: patientData?.permanent_zip_code ?? null,
    // updated_by: null`
});


const uploadSRID = (e: Event) => {
    const file:File  = e.target.files[0];

    createBase64Image(file, 'senior_citizen_id_base_64')

    uploadedFileName1.value = removeFakePath((e.target as HTMLInputElement).value);
}


const removeSRID = () => {
    payload.value.senior_citizen_id_base_64 = null;
    uploadedFileName1.value = null;
}

const uploadPWDID = (e: Event) => {
    const file:File  = e.target.files[0];

    createBase64Image(file, 'pwd_id_base_64')

    uploadedFileName2.value = removeFakePath((e.target as HTMLInputElement).value);
}

const removeFakePath = (path:string):string => {
    return path.replace(/.*\\fakepath\\/g, "");
}

const removePWDID = () => {
    payload.value.pwd_id_base_64 = null;
    uploadedFileName2.value = null;
}

const createBase64Image = (FileObject:File, item:string)=> {

    const reader = new FileReader();
    
    reader.onload = (event) => {
        payload.value[item] = event.target.result;
    }
    
    reader.readAsDataURL(FileObject);
}

const submit = () => show.value = true

const submitForm = () => {
    patient.updateMedicalRecord(payload.value)
        .then((result: any) => {
            loader.value      = false;
            show.value        = false;
            showSuccess.value = true
            storage.set('patient', JSON.stringify(result.data.response.response))

            setTimeout(() => {
                window.location.reload()
            }, 3000);
        })
        .catch((err) => {
            loader.value    = false;
            show.value      = false;
            showError.value = true;
            errorMsg.value  = err.response.data.message;

            if(err.response.status == 422) {
                errors.value = err.response.data.errors;
            }
            errorResponse(err)
        })
}

const errorResponse = (err: object) => {
    loader.value = false

    if(err?.response.status == 401) {
        auth.redirectToLogin()
    }
}

const fetchData = () => {
    loader.value = true

    location.fetchProvinces()
        .then((result: any) => {
            loader.value = false
            provinces.value = result.data
            permanentProvinces.value = result.data
        })
        .catch((err: any) => errorResponse(err) )
}

const fetchCity = () => {
    loader.value = true

    location.fetchCities(`code=${payload.value.province_code}&level=Mun`)
    .then((result: any) => {
        loader.value = false
        cities.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const formatHmos = (hmos: Array<number | string | null>) => {
    hmos.forEach(hmo => {
        hmoOptions.value.push({ id: hmo.hmo_id, label: hmo.hmo_name, value: hmo.hmo_id})
    });
}

const fetchHmos = async () => {
    try {
        loader.value = true;
        const response = await medical.getHmos();
        loader.value = false;
        
        formatHmos(response?.data);
    }
    catch(error: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error
    }
}

/**
 * 
 * Local Address Functions
 * 
 */
const fetchBrgy = () => {
    loader.value = true

    location.fetchBarangays(`code=${payload.value.city_code}&level=Bgy`)
    .then((result: any) => {
        loader.value = false
        barangays.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const clearCity = () => {
    payload.value.city = null
    payload.value.city_code = null
    payload.value.barangay = null
    payload.value.barangay_code = null
}

const clearBgy = () => {
    payload.value.barangay = null
    payload.value.barangay_code = null
}

/**
 * 
 * Local Address Functions
 * 
 */
const fetchPermanentCity = () => {
    loader.value = true
    location.fetchCities(`code=${payload.value.permanent_province_code}&level=Mun`)
    .then((result: any) => {
        loader.value = false
        permanentCities.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const fetchPermanentBrgy = () => {
    loader.value = true
    location.fetchBarangays(`code=${payload.value.permanent_city_code}&level=Bgy`)
    .then((result: any) => {
        loader.value = false
        permanentBarangays.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const clearPermanentCity = () => {
    payload.value.permanent_city = null
    payload.value.permanent_city_code = null
    payload.value.permanent_barangay = null
    payload.value.permanent_barangay_code = null
}

const clearPermanentBgy = () => {
    payload.value.permanent_barangay = null
    payload.value.permanent_barangay_code = null
}

watch(
      () => payload.value.barangay_code,
      (val) => {
        payload.value.barangay = barangays.value.find(x => x.code == val)?.label;
      },
      { immediate: true }
    );
 
watch(
      () => payload.value.city_code,
      (val) => {
        payload.value.city = cities.value.find(x => x.code == val)?.label;
        barangays.value = [];
        fetchBrgy()
      },
      { immediate: true }
    );

watch(
      () => payload.value.province_code,
      (val) => {
        payload.value.province = provinces.value.find(x => x.code == val)?.label;
        cities.value = [];
        barangays.value = [];
        fetchCity()
      },
      { immediate: true }
    );
    
watch(
    () => payload.value.hmo_id,
    (val) => {
        const selectedHMO = hmoOptions.value.filter((item:any) => item.id == val);

        if(selectedHMO.length > 0){
            payload.value.hmo_name = selectedHMO[0].label
        } else {
            payload.value.hmo_name = null;
        }

    },
    { immediate: true }
);

// Permanenet Address
watch(
    () => payload.value.permanent_barangay_code,
    (val) => {
        payload.value.permanent_barangay = sameAsLocal.value ? payload.value.permanent_barangay : permanentBarangays.value.find(x => x.code == val)?.label;
    },
    { immediate: true }
);

watch(
      () => payload.value.permanent_city_code,
      (val) => {
            payload.value.permanent_city = sameAsLocal.value ? payload.value.permanent_city : permanentCities.value.find(x => x.code == val)?.label;
            permanentBarangays.value = [];
            fetchPermanentBrgy()
      },
      { immediate: true }
    );

watch(
      () => payload.value.permanent_province_code,
      (val) => {
        if(val) {
            payload.value.permanent_province = sameAsLocal.value ? payload.value.permanent_province : permanentProvinces.value.find(x => x.code == val)?.label;
            permanentCities.value = [];
            permanentBarangays.value = [];
            fetchPermanentCity()
        }
        
      },
      { immediate: true }
    );

watch(
    () => sameAsLocal.value,
    (val) => {

        payload.value.permanent_building_number = null;
        payload.value.permanent_street = null;
        payload.value.permanent_barangay = null;
        payload.value.permanent_barangay_code = null;
        payload.value.permanent_city = null;
        payload.value.permanent_city_code = null;
        payload.value.permanent_province = null;
        payload.value.permanent_province_code = null;
        payload.value.permanent_region = null;
        payload.value.permanent_region_code = null;
        payload.value.permanent_zip_code = null;
        
        if(val 
            && payload.value.province 
            && payload.value.province_code 
            && payload.value.city
            && payload.value.city_code
            && payload.value.barangay
            && payload.value.barangay_code
            && payload.value.building_number
            && payload.value.street) {

            Object.assign(payload.value, {
                permanent_building_number: payload.value.building_number,
                permanent_street: payload.value.street,
                permanent_barangay: payload.value.barangay,
                permanent_barangay_code: payload.value.barangay_code,
                permanent_city: payload.value.city,
                permanent_city_code: payload.value.city_code,
                permanent_province: payload.value.province,
                permanent_province_code: payload.value.province_code,
                permanent_region: payload.value.region,
                permanent_region_code: payload.value.region_code,
                permanent_zip_code: payload.value.zip_code,
            })
        }
      },
    //   { immediate: true }
    );


onMounted(() => {
    fetchData()
    fetchHmos()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!showForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(ButtonComponent, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showForm.value = true)),
            text: "Fill up now"
          })
        ]))
      : _createCommentVNode("", true),
    (showForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.suffix,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.suffix) = $event)),
                    disabled: !!_unref(patientData)?.suffix,
                    id: "suffix",
                    type: "text",
                    placeholder: "Suffix",
                    error: errors.value.suffix ? errors.value.suffix[0] : ''
                  }, null, 8, ["modelValue", "disabled", "error"])
                ]),
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.first_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.first_name) = $event)),
                    disabled: !!_unref(patientData)?.first_name,
                    id: "first-name",
                    type: "text",
                    placeholder: "First Name",
                    error: errors.value.first_name ? errors.value.first_name[0] : ''
                  }, null, 8, ["modelValue", "disabled", "error"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.middle_name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.middle_name) = $event)),
                    disabled: !!_unref(patientData)?.middle_name,
                    id: "middle-name",
                    type: "text",
                    placeholder: "Middle Name"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.last_name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.last_name) = $event)),
                    disabled: !!_unref(patientData)?.first_name,
                    id: "last-name",
                    type: "text",
                    placeholder: "Last Name",
                    error: errors.value.last_name ? errors.value.last_name[0] : ''
                  }, null, 8, ["modelValue", "disabled", "error"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(MultiselectInput, {
                    name: "sex",
                    id: "sex",
                    modelValue: payload.value.sex,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.sex) = $event)),
                    disabled: !!_unref(patientData)?.sex,
                    placeholder: "Sex",
                    options: _unref(sexes),
                    error: errors.value.sex ? errors.value.sex[0] : ''
                  }, null, 8, ["modelValue", "disabled", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.nationality,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.nationality) = $event)),
                    id: "nationality",
                    type: "text",
                    placeholder: "Nationality",
                    error: errors.value.nationality ? errors.value.nationality[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(CalendarPicker, {
                    modelValue: payload.value.birthdate,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((payload.value.birthdate) = $event)),
                    disabled: !!_unref(patientData)?.birthdate,
                    id: "date-of-birth",
                    inline: false,
                    placeholder: "Date of Birth",
                    isTodayMaxDate: "",
                    error: errors.value.birthdate ? errors.value.birthdate[0] : ''
                  }, null, 8, ["modelValue", "disabled", "error"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.telephone_number,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.telephone_number) = $event)),
                    id: "telephone",
                    type: "text",
                    placeholder: "Telephone Number",
                    error: errors.value.telephone_number ? errors.value.telephone_number[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(MultiselectInput, {
                    name: "civil_status",
                    id: "civil_status",
                    modelValue: payload.value.civil_status,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((payload.value.civil_status) = $event)),
                    placeholder: "Civil Status",
                    options: _unref(civilStatuses),
                    error: errors.value.civil_status ? errors.value.civil_status[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.email_address,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.email_address) = $event)),
                    disabled: !!_unref(patientData)?.email_address,
                    id: "email",
                    type: "email",
                    placeholder: "Email Address",
                    error: errors.value.email_address ? errors.value.email_address[0] : ''
                  }, null, 8, ["modelValue", "disabled", "error"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(TextInput, {
                    id: "cellphone_number",
                    name: "cellphone_number",
                    add_on_left: true,
                    add_on_text: "+63",
                    onKeypress: _unref(onKeypressNumbersOnly),
                    onPaste: _unref(onPasteNumbersOnly),
                    placeholder: 'Cellphone Number',
                    maxlength: 10,
                    modelValue: payload.value.cellphone_number,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((payload.value.cellphone_number) = $event)),
                    disabled: _unref(patientData)?.cellphone_number != 'TBA' || !_unref(patientData)?.cellphone_number,
                    error: errors.value.cellphone_number ? errors.value.cellphone_number[0] : ''
                  }, null, 8, ["onKeypress", "onPaste", "modelValue", "disabled", "error"])
                ])
              ]),
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(MultiselectInput, {
                    id: "province",
                    modelValue: payload.value.province_code,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((payload.value.province_code) = $event)),
                    placeholder: "Province",
                    options: provinces.value,
                    onClick: clearCity,
                    error: errors.value.province ? errors.value.province[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(MultiselectInput, {
                    id: "city",
                    modelValue: payload.value.city_code,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((payload.value.city_code) = $event)),
                    placeholder: "City/Municipality",
                    options: cities.value,
                    onClick: clearBgy,
                    error: errors.value.city ? errors.value.city[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(MultiselectInput, {
                    id: "barangay",
                    modelValue: payload.value.barangay_code,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((payload.value.barangay_code) = $event)),
                    placeholder: "Barangay",
                    options: barangays.value,
                    error: errors.value.barangay ? errors.value.barangay[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(TextInput, {
                    id: "street",
                    modelValue: payload.value.street,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((payload.value.street) = $event)),
                    type: "text",
                    placeholder: "Street",
                    error: errors.value.street ? errors.value.street[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(TextInput, {
                    id: "bldg",
                    modelValue: payload.value.building_number,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((payload.value.building_number) = $event)),
                    type: "text",
                    placeholder: "No./Bldg.",
                    error: errors.value.building_number ? errors.value.building_number[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(TextInput, {
                    id: "zipcode",
                    modelValue: payload.value.zip_code,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((payload.value.zip_code) = $event)),
                    type: "text",
                    maxlength: 4,
                    onKeypress: _unref(onKeypressNumbersOnly),
                    onPaste: _unref(onPasteNumbersOnly),
                    placeholder: "ZIP Code",
                    error: errors.value.zip_code ? errors.value.zip_code[0] : ''
                  }, null, 8, ["modelValue", "onKeypress", "onPaste", "error"])
                ])
              ]),
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(CheckboxInput, {
                  id: "check",
                  label: "Same as Local Address",
                  modelValue: sameAsLocal.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((sameAsLocal).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(MultiselectInput, {
                    id: "permanent_province",
                    modelValue: payload.value.permanent_province_code,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((payload.value.permanent_province_code) = $event)),
                    placeholder: "Province",
                    options: permanentProvinces.value,
                    onClick: clearPermanentCity,
                    error: errors.value.permanent_province ? errors.value.permanent_province[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(MultiselectInput, {
                    id: "permanent_city",
                    modelValue: payload.value.permanent_city_code,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((payload.value.permanent_city_code) = $event)),
                    placeholder: "City",
                    options: permanentCities.value,
                    onClick: clearPermanentBgy,
                    error: errors.value.permanent_city ? errors.value.permanent_city[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(MultiselectInput, {
                    id: "permanent_barangay",
                    modelValue: payload.value.permanent_barangay_code,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((payload.value.permanent_barangay_code) = $event)),
                    placeholder: "Barangay",
                    options: permanentBarangays.value,
                    error: errors.value.permanent_barangay ? errors.value.permanent_barangay[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(TextInput, {
                    id: "permanent_street",
                    modelValue: payload.value.permanent_street,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((payload.value.permanent_street) = $event)),
                    type: "text",
                    placeholder: "Street",
                    error: errors.value.permanent_street ? errors.value.permanent_street[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(TextInput, {
                    id: "permanent_bldg",
                    modelValue: payload.value.permanent_building_number,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((payload.value.permanent_building_number) = $event)),
                    type: "text",
                    placeholder: "No./Bldg.",
                    error: errors.value.permanent_building_number ? errors.value.permanent_building_number[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(TextInput, {
                    id: "permanent_zipcode",
                    modelValue: payload.value.permanent_zip_code,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((payload.value.permanent_zip_code) = $event)),
                    type: "text",
                    maxlength: 4,
                    onKeypress: _unref(onKeypressNumbersOnly),
                    onPaste: _unref(onPasteNumbersOnly),
                    placeholder: "ZIP Code",
                    error: errors.value.permanent_zip_code ? errors.value.permanent_zip_code[0] : ''
                  }, null, 8, ["modelValue", "onKeypress", "onPaste", "error"])
                ])
              ]),
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.philhealth_number,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((payload.value.philhealth_number) = $event)),
                    id: "philhealth",
                    type: "text",
                    placeholder: "Philhealth No.",
                    error: errors.value.philhealth_number ? errors.value.philhealth_number[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(MultiselectInput, {
                    modelValue: payload.value.hmo_id,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((payload.value.hmo_id) = $event)),
                    id: "hmo",
                    placeholder: "HMO",
                    options: hmoOptions.value,
                    error: errors.value.hmo ? errors.value.hmo[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["absolute top-3 left-5 z-[1] duration-300 origin-[0] text-gray-20 focus-within:text-primary-500", uploadedFileName1.value ? 'scale-[.60] -translate-y-2.5' : 'scale-100 translate-y-0'])
                    }, " Senior Citizen ID (optional) ", 2),
                    _createElementVNode("input", {
                      id: "senior_citizen",
                      type: "file",
                      class: "hidden",
                      onChange: uploadSRID,
                      accept: "image/*"
                    }, null, 32),
                    (uploadedFileName1.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(uploadedFileName1.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (uploadedFileName1.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "border-0",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (removeSRID()))
                        }, [
                          _createVNode(_unref(XMarkIcon), {
                            class: "w-5 h-5 transition text-gray-20 hover:text-red-500",
                            "aria-hidden": "true"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["absolute top-3 left-5 z-[1] duration-300 origin-[0] text-gray-20 focus-within:text-primary-500", uploadedFileName2.value ? 'scale-[.60] -translate-y-2.5' : 'scale-100 translate-y-0'])
                    }, " PWD ID (optional) ", 2),
                    _createElementVNode("input", {
                      id: "pwd_id",
                      type: "file",
                      class: "hidden",
                      onChange: uploadPWDID,
                      accept: "image/*"
                    }, null, 32),
                    (uploadedFileName2.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(uploadedFileName2.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (uploadedFileName2.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "border-0",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (removePWDID()))
                        }, [
                          _createVNode(_unref(XMarkIcon), {
                            class: "w-5 h-5 transition text-gray-20 hover:text-red-500",
                            "aria-hidden": "true"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.job_title,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((payload.value.job_title) = $event)),
                    id: "job-title",
                    type: "text",
                    placeholder: "Title",
                    error: errors.value.job_title ? errors.value.job_title[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.company_name,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((payload.value.company_name) = $event)),
                    id: "company-name",
                    type: "text",
                    placeholder: "Company Name",
                    error: errors.value.company_name ? errors.value.company_name[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.company_contact_no,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((payload.value.company_contact_no) = $event)),
                    id: "contact-number",
                    type: "text",
                    placeholder: "Contact Number",
                    error: errors.value.company_contact_no ? errors.value.company_contact_no[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.company_email,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((payload.value.company_email) = $event)),
                    id: "company-email",
                    type: "text",
                    placeholder: "Company Email Address",
                    error: errors.value.company_email ? errors.value.company_email[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.company_address,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((payload.value.company_address) = $event)),
                    id: "address",
                    type: "text",
                    placeholder: "Address",
                    error: errors.value.company_address ? errors.value.company_address[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.contact_person_name,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((payload.value.contact_person_name) = $event)),
                    id: "emergency-name",
                    type: "text",
                    placeholder: "Name",
                    error: errors.value.contact_person_name ? errors.value.contact_person_name[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(MultiselectInput, {
                    modelValue: payload.value.contact_person_relationship,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((payload.value.contact_person_relationship) = $event)),
                    id: "relationship",
                    placeholder: "Relationship",
                    options: _unref(medical).getRelationships(),
                    error: errors.value.contact_person_relationship ? errors.value.contact_person_relationship[0] : ''
                  }, null, 8, ["modelValue", "options", "error"])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(TextInput, {
                    id: "contact_person_number",
                    name: "contact_person_number",
                    add_on_left: true,
                    add_on_text: "+63",
                    onKeypress: _unref(onKeypressNumbersOnly),
                    onPaste: _unref(onPasteNumbersOnly),
                    placeholder: 'Contact Number',
                    maxlength: 10,
                    modelValue: payload.value.contact_person_number,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((payload.value.contact_person_number) = $event)),
                    error: errors.value.contact_person_number ? errors.value.contact_person_number[0] : ''
                  }, null, 8, ["onKeypress", "onPaste", "modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.contact_person_email,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((payload.value.contact_person_email) = $event)),
                    id: "emergency-email",
                    type: "text",
                    placeholder: "Email Address",
                    error: errors.value.contact_person_email ? errors.value.contact_person_email[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ])
              ])
            ]),
            _createVNode(ButtonComponent, {
              type: `submit`,
              text: "Save"
            })
          ], 40, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createVNode(GeneralModal, {
      width: "w-[548px]",
      title: "Confirm Information",
      "action-text": "Submit",
      "cancel-text": "Go back",
      show: show.value,
      onClose: _cache[38] || (_cache[38] = ($event: any) => (show.value = false)),
      onConfirm: _cache[39] || (_cache[39] = ($event: any) => (submitForm()))
    }, {
      content: _withCtx(() => [
        _hoisted_68,
        _hoisted_69,
        _hoisted_70
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(GeneralModal, {
      width: "w-[416px]",
      title: "Success!",
      content: "Your Patient Record has been submitted successfully.",
      "action-text": "Ok",
      show: showSuccess.value,
      onClose: _cache[40] || (_cache[40] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[41] || (_cache[41] = ($event: any) => (showSuccess.value = false))
    }, null, 8, ["show"]),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[42] || (_cache[42] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[43] || (_cache[43] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMsg.value), 1)
      ]),
      _: 1
    }, 8, ["show", "errors"])
  ]))
}
}

})